import { Eyebrow } from '@busbook/ui';
import { useTenant } from '../lib/tenant.js';
import { SearchForm } from '../components/SearchForm.js';
import { useT } from '../i18n/index.js';

/**
 * The hero is the search itself. A passenger opens this app to answer one
 * question — "when can I leave?" — so the form is the first thing, not a
 * marketing panel above it.
 */
export function Home() {
  const t = useT();
  const { branding, settings } = useTenant();

  return (
    <section className="px-4 pb-8 pt-7">
      <Eyebrow>{t('c.departures')}</Eyebrow>
      <h1 className="mt-2 max-w-[15ch] text-[1.75rem] font-semibold leading-[1.15] tracking-tight">
        {t('h.whereTo')}
      </h1>

      <div className="mt-6">
        <SearchForm />
      </div>

      <p className="mt-6 text-xs" style={{ color: 'var(--color-faint)' }}>
        {t('h.footer', {
          tz: settings.timezone.replace(/_/g, ' '),
          currency: settings.currency,
          operator: branding.appName,
        })}
      </p>
    </section>
  );
}
